import { Block } from '@/components/base/Block'
import { useApp } from '@/hooks/useApp'
import { Text4, Text5 } from '@/components/base/Text'
import spaceStyle from '@/styles/space'
import { Row } from '@/components/base/Layout'
import { Icon, LocalIconType } from '@/components/base/Icon'
import { fontSize } from '@/styles/font'
import { AccentButton } from '@/components/base/Button'
import { JobPostingTitleComponent } from '@/components/JobPosting/JobPostingTitle'
import CardLabels from '@/components/JobPosting/Labels'
import { type ReactNode } from 'react'
import {
  type V1IconType,
  type V1JobPostingCardAttachmentInfo,
  type Labelsv1Label,
  type V1Tag
} from 'mnvm-mypage-app-ts-if'
import CardTags from '../Tags'
import FavoriteIcon from '@/components/base/Icon/FavoriteIcon'

interface JobInformationItem {
  iconType?: LocalIconType | V1IconType
  text: string
  maxLines?: number
}

export const JobInformation = (props: JobInformationItem): JSX.Element => {
  const app = useApp()
  return (
    <Block padding={{ vertical: spaceStyle.XS }}>
      <Row flexWrap="nowrap">
        <Icon
          iconType={props.iconType ?? 'ICON_TYPE_HOME'}
          iconStyle={{ fontSize: fontSize.M, theme: app.theme.subTextColor }}
        />
        <Text4
          textColor={app.theme.subTextColor}
          margin={{ vertical: spaceStyle.NONE }}
          fontSize={fontSize.XXS}
          maxLines={props.maxLines ?? 2}
        >
          {props.text}
        </Text4>
      </Row>
    </Block>
  )
}

export interface JobPostingCardType1Props {
  labels: Labelsv1Label[]
  tags: V1Tag[]
  attachmentInfo?: V1JobPostingCardAttachmentInfo[]
  title: string
  smallTitle: string
  companyName: string
  recommendCommentFromAdvisor?: ReactNode
  isShowFavoriteButton?: boolean
  code: string
  isLiked?: boolean
}

const JobPostingCardType1 = (props: JobPostingCardType1Props): JSX.Element => {
  const app = useApp()
  return (
    <Block
      border
      borderRadius={{ all: spaceStyle.XS }}
      textAlign="left"
      padding={{ horizontal: spaceStyle.S, bottom: spaceStyle.XS }}
      style={{ width: '100%', boxSizing: 'border-box', position: 'relative' }}
      margin={{ horizontal: spaceStyle.AUTO, top: spaceStyle.M }}
    >
      <CardLabels items={props.labels} />
      <Block textAlign="left" borderBottom margin={{ bottom: spaceStyle.S }}>
        <JobPostingTitleComponent
          isCard
          title={props.title}
          smallTitle={props.smallTitle}
        />
        <CardTags tags={props.tags} />
      </Block>
      <Text4
        textColor={app.theme.subTextColor}
        margin={{ top: spaceStyle.NONE, bottom: spaceStyle.XS }}
      >
        {props.companyName}
      </Text4>
      {props.attachmentInfo?.map((e) => {
        return (
          <JobInformation
            key={e.text}
            iconType={e.iconType}
            text={e.text ?? ''}
          />
        )
      })}

      {props.recommendCommentFromAdvisor !== undefined && (
        <Block margin={{ vertical: spaceStyle.S }}>
          {props.recommendCommentFromAdvisor}
        </Block>
      )}
      <Text5
        textColor={app.theme.subTextColor}
        margin={{ top: spaceStyle.NONE, bottom: spaceStyle.XS }}
      >
        求人番号：{props.code}
      </Text5>
      {(props.isShowFavoriteButton ?? false) && (
        <AccentButton
          fontSize={fontSize.S}
          padding={{
            all: spaceStyle.S
          }}
          width="44px"
          borderRadius="22px"
          style={{ position: 'absolute', bottom: 8, right: 8, height: 44 }}
        >
          <FavoriteIcon
            iconTypeProp={LocalIconType.Favorite}
            themeProp={app.theme.inactiveColor}
            fontSizeProp={fontSize.XL}
            paddingProp={{ all: spaceStyle.AUTO }}
            isLiked={props.isLiked}
          />
        </AccentButton>
      )}
    </Block>
  )
}

export default JobPostingCardType1
